module.exports = __webpack_public_path__ + "static/media/enterprise.feceb085.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Plans/enterprise.svg
// module id = 528
// module chunks = 0